module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/voice-02-299b073cb31823cc4e8a5ddb4d60c978.svg";